import React from 'react';

export default function Map() {
  return (
    <div className="map my-4">
      <iframe title="Sharaaninfo" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31109.396506578607!2d77.6069044!3d12.9286259!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9398e881638528a!2sSharaan%20Infosystems!5e0!3m2!1sen!2sin!4v1635156775196!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" className="iframe" ></iframe>
    </div>
  );
}